var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Modal } from 'pcln-modal';
import { Button, Flex } from 'pcln-design-system';
import { ArrowLeft } from 'pcln-icons';
var FlexButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n\n  &:focus {\n    box-shadow: none;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n\n  &:focus {\n    box-shadow: none;\n  }\n"])), function (props) { return props.height; });
/** @public */
var InputModal = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.height, height = _b === void 0 ? '48px' : _b, id = _a.id, imgMode = _a.imgMode, input = _a.input, isOpen = _a.isOpen, onClose = _a.onClose;
    return (React.createElement(Modal, { ariaLabelledBy: id, className: className, disableCloseButton: true, fullScreen: true, header: React.createElement(Flex, { alignItems: 'center', width: 1, pt: 3, px: 3 },
            React.createElement(FlexButton, { "aria-label": 'Close', height: height, mr: 2, onClick: onClose },
                React.createElement(ArrowLeft, null)),
            React.cloneElement(input, { autoFocus: true, height: height, width: 1 })), imgMode: imgMode, isOpen: isOpen, timeout: 0, onClose: onClose }, children));
};
export default InputModal;
var templateObject_1;
//# sourceMappingURL=InputModal.js.map